import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { PageHero } from '../components/ui/PageHero';
import { LegalDocument } from '../components/ui/LegalDocument';
import { termsSections } from '../data/legal';
export function TermsOfUse() {
  usePageMeta('Terms of Use (Draft) | Avenqor Talent Search', 'Draft terms of use for the Avenqor Talent Search website, pending legal review.');
  return <>
      <PageHero eyebrow="Legal" title="Terms of Use" intro="The terms that govern use of this website. This is a draft pending legal review." data-id="element-580" data-mp="2srhirecsxl60" />
      <LegalDocument sections={termsSections} data-id="element-581" data-mp="2iuuxwpkh6u3z" />
    </>;
}